import React from "react";
import { Spin, Progress } from "antd";

export function TicketProgressBar({ active }) {
  if (!active) return null;
  return (
    <div className="ticket-top-progress">
      <Progress percent={100} showInfo={false} status="active" strokeColor="#6366f1" size="small" />
    </div>
  );
}

export default function TicketBusy({ spinning, tip = "Please wait…", children, block = true }) {
  if (children == null) {
    return spinning ? <Spin tip={tip} style={{ display: "block", margin: "80px auto" }} /> : null;
  }

  return (
    <Spin spinning={!!spinning} tip={tip} wrapperClassName={block ? "ticket-busy-wrap" : undefined}>
      {children}
    </Spin>
  );
}
